<template>
  <CockpitCard cardType="fullscreen" class="w-full h-full overflow-y-scroll">
    <div class="w-full flex justify-between items-center">
      <span class="text-20px text-[#fff] font-bold">当前班组：运行{{ currentTeam }}</span>
      <span class="text-40px text-[#fff] font-bold my-10px">交接班信息看板</span>
      <span class="mr-30px">
        <span class="text-14px text-[#fff]">日期：</span>
        <el-date-picker
          v-model="search.time"
          @change="getRotaByDateTimeAndShift"
          popper-class="visualization-picker-popper"
          type="date"
          placeholder="选择日期"
          class="unglobal-sty mr-10px"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <el-select
          class="unglobal-sty mr-10px"
          popper-class="visualization-select-popper"
          v-model="search.workName"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in workType"
            :key="item.id"
            :label="item.displayName"
            :value="item.displayName"
          >
          </el-option>
        </el-select>
      </span>
    </div>
    <div class="w-full flex justify-between overflow-y-hidden">
      <div class="w-1/3 mr-10px">
        <CockpitCard class="h-176px mb-10px box-border overflow-hidden" cardType="horizontal">
          <template slot-scope="scope">
            <div class="w-full">
              <CardTitle title="#3机组状态"></CardTitle>
            </div>
            <div class="h-full">
              <ul class="h-full text-16px !text-[#fff]">
                <li
                  class="my-10px pl-30px h-40px leading-40px setStatus"
                  v-for="(item, i) in unit3Data"
                  :key="i"
                >
                  {{ item.deviceName
                  }}<span class="text-20px text-[#11D45F]">{{ item.eligibleData['状态'] }}</span
                  >，负荷<span class="text-20px text-[#FF8900]">{{
                    _.ceil(item.eligibleData['负荷'], 2)
                  }}</span
                  >MW，<span class="text-20px text-[#FF8900]">{{ item.eligibleData['并网'] }}</span>
                </li>
                <!-- <li class="my-10px pl-30px h-40px leading-40px setStatus">
                  三号燃气轮机<span class="text-20px text-[#11D45F]">运行状态</span>，负荷<span
                    class="text-20px text-[#FF8900]"
                    >50</span
                  >MW，<span class="text-20px text-[#FF8900]">并网220KV Ⅲ母线</span>
                </li> -->
              </ul>
            </div>
          </template>
        </CockpitCard>
        <CockpitCard class="h-20rem mb-10px box-border overflow-hidden" cardType="horizontal">
          <template slot-scope="scope">
            <div class="w-full">
              <CardTitle title="#3机组本班工作"></CardTitle>
            </div>
            <div class="h-full overflow-y-scroll">
              <ul class="h-full text-16px !text-[#fff] mb-3rem">
                <li class="my-10px h-36px leading-36px flex items-center ourClass">
                  <span class="beforeImg w-20px h-20px px-20px"></span>
                  <span class="flex-1">
                    发现<span class="text-20px text-[#FF8900]">5</span>条缺陷，其中重要缺陷<span
                      class="text-20px text-[#FF8900]"
                      >1</span
                    >条
                  </span>
                  <span class="afterImg w-20px h-20px px-30px"></span>
                </li>
                <li class="my-10px h-36px leading-36px flex items-center ourClass">
                  <span class="beforeImg w-20px h-20px px-20px"></span>
                  <span class="flex-1">
                    启动<span class="text-20px text-[#FF8900]">15</span>次设备，停止<span
                      class="text-20px text-[#FF8900]"
                      >16</span
                    >次设备
                  </span>
                  <span class="afterImg w-20px h-20px px-30px"></span>
                </li>
                <li class="my-10px h-36px leading-36px flex items-center ourClass">
                  <span class="beforeImg w-20px h-20px px-20px"></span>
                  <span class="flex-1">
                    执行定期工作<span class="text-20px text-[#FF8900]">20</span
                    >项，未执行定期工作<span class="text-20px text-[#FF8900]">2</span>项
                  </span>
                  <span class="afterImg w-20px h-20px px-30px"></span>
                </li>
                <li class="my-10px h-36px leading-36px flex items-center ourClass">
                  <span class="beforeImg w-20px h-20px px-20px"></span>
                  <span class="flex-1">
                    #3机组许可<span class="text-20px text-[#FF8900]">5</span>张工作票，终结<span
                      class="text-20px text-[#FF8900]"
                      >2</span
                    >张工作票
                  </span>
                  <span class="afterImg w-20px h-20px px-30px"></span>
                </li>
                <li class="my-10px h-36px leading-36px flex items-center ourClass">
                  <span class="beforeImg w-20px h-20px px-20px"></span>
                  <span class="flex-1">
                    完成操作票<span class="text-20px text-[#FF8900]">20</span>项
                  </span>
                  <span class="afterImg w-20px h-20px px-30px"></span>
                </li>
                <li
                  class="
                    my-10px
                    flex
                    w-full
                    box-border
                    overflow-hidden
                    h-66px
                    leading-66px
                    ourClass
                  "
                >
                  <span class="beforeImg mt-6px w-20px h-20px px-20px"></span>
                  <span class="w-[calc(100%-100px)] h-full leading-33px">
                    #3机组退出<span class="text-20px text-[#FF8900]">差动保护、过电流保护压板</span
                    >，投入<span class="text-20px text-[#FF8900]">低压测过电流压板</span>
                  </span>
                  <span class="afterImg mt-6px w-20px h-20px px-30px"></span>
                </li>
              </ul>
            </div>
          </template>
        </CockpitCard>
        <CockpitCard class="h-272.56px box-border overflow-hidden" cardType="horizontal">
          <template slot-scope="scope">
            <div class="w-full">
              <CardTitle title="#3机组下班工作"></CardTitle>
            </div>
            <div class="w-full h-full flex">
              <div class="w-1/5">
                <div class="flex my-10px flex-col justify-center">
                  <div class="regularWork mx-auto w-93.21px h-100px"></div>
                  <div class="w-full pt-10px pb-15px text-center text-16px font-bold text-[#fff]">
                    定期工作
                  </div>
                  <div
                    class="
                      w-full
                      flex
                      justify-center
                      items-center
                      h-37px
                      text-center text-16px text-[#fff]
                      relative
                      numItem
                    "
                  >
                    <span class="leading-37px font-bold text-20px fontFamily">10</span>
                    <span class="leading-37px">项</span>
                    <span class="absolute w-20px h-20px right-4px afterImg"></span>
                  </div>
                </div>
              </div>
              <div class="w-2/5">
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">汽机专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">锅炉专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">汽机专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">汽机专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
              </div>
              <div class="w-2/5">
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">汽机专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">汽机专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">汽机专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
              </div>
            </div>
          </template>
        </CockpitCard>
      </div>
      <div class="w-1/3 mx-10px">
        <CockpitCard class="h-373px mb-10px box-border overflow-hidden" cardType="horizontal">
          <template slot-scope="scope">
            <div class="w-full">
              <CardTitle title="安全作业设备监控"></CardTitle>
            </div>
            <div class="h-full">
              <ul class="h-full text-16px !text-[#fff]">
                <li class="my-10px h-38px leading-40px pl-44px midTopImg">
                  <span class="text-24px text-[#44F1FF] pr-20px">01</span> 总工处钥匙在线<span
                    class="text-20px text-[#FF8900]"
                    >9</span
                  >把，离线<span class="text-20px text-[#FF8900]">1</span>把
                </li>
                <li class="my-10px h-38px leading-40px pl-44px midTopImg">
                  <span class="text-24px text-[#44F1FF] pr-20px">02</span> 总工处钥匙在线<span
                    class="text-20px text-[#FF8900]"
                    >9</span
                  >把，离线<span class="text-20px text-[#FF8900]">1</span>把
                </li>
                <li class="my-10px h-38px leading-40px pl-44px midTopImg">
                  <span class="text-24px text-[#44F1FF] pr-20px">03</span> 总工处钥匙在线<span
                    class="text-20px text-[#FF8900]"
                    >9</span
                  >把，离线<span class="text-20px text-[#FF8900]">1</span>把
                </li>
                <li class="my-10px h-38px leading-40px pl-44px midTopImg">
                  <span class="text-24px text-[#44F1FF] pr-20px">04</span> 总工处钥匙在线<span
                    class="text-20px text-[#FF8900]"
                    >9</span
                  >把，离线<span class="text-20px text-[#FF8900]">1</span>把
                </li>
                <li class="my-10px h-38px leading-40px pl-44px midTopImg">
                  <span class="text-24px text-[#44F1FF] pr-20px">05</span> 总工处钥匙在线<span
                    class="text-20px text-[#FF8900]"
                    >9</span
                  >把，离线<span class="text-20px text-[#FF8900]">1</span>把
                </li>
                <li class="my-10px h-38px leading-40px pl-44px midTopImg">
                  <span class="text-24px text-[#44F1FF] pr-20px">06</span> 总工处钥匙在线<span
                    class="text-20px text-[#FF8900]"
                    >9</span
                  >把，离线<span class="text-20px text-[#FF8900]">1</span>把
                </li>
              </ul>
            </div>
          </template>
        </CockpitCard>
        <CockpitCard class="h-25rem box-border overflow-hidden" cardType="horizontal">
          <template slot-scope="scope">
            <div class="w-full">
              <CardTitle title="部门通知"></CardTitle>
            </div>
            <div class="h-20rem overflow-y-scroll">
              <ul class="h-full text-16px !text-[#fff]">
                <li
                  class="my-10px py-10px leading-47px flex items-center midBottomImg"
                  v-for="item in departmentalNotificationList"
                  :key="item.id"
                  @click="showDialog(item)"
                >
                  <span
                    class="w-44px h-36px mx-5px flex flex-col text-center justify-center dateImg"
                  >
                    <span class="text-12px !leading-16.33px text-[#fff]">{{
                      dayjs(item.publishTime).format('YYYY')
                    }}</span>
                    <span class="text-12px !leading-16.33px text-[#fff]">{{
                      dayjs(item.publishTime).format('MM-DD')
                    }}</span>
                  </span>
                  <span class="h-full text-14px !leading-17.78px pl-5px flex-1 midBottomText">{{
                    item.title
                  }}</span>
                  <span class="text-14px text-[#FBFF11] mx-20px">{{
                    JSON.parse(item.publisherNames)[0]
                  }}</span>
                </li>
              </ul>
            </div>
          </template>
        </CockpitCard>
      </div>
      <div class="w-1/3 mr-10px">
        <CockpitCard class="h-176px mb-10px box-border overflow-hidden" cardType="horizontal">
          <template slot-scope="scope">
            <div class="w-full">
              <CardTitle title="#4机组状态"></CardTitle>
            </div>
            <div class="h-full">
              <ul class="h-full text-16px !text-[#fff]">
                <li
                  class="my-10px pl-30px h-40px leading-40px setStatus"
                  v-for="(item, i) in unit4Data"
                  :key="i"
                >
                  {{ item.deviceName
                  }}<span class="text-20px text-[#11D45F]">{{ item.eligibleData['状态'] }}</span
                  >，负荷<span class="text-20px text-[#FF8900]">{{
                    _.ceil(item.eligibleData['负荷'], 2)
                  }}</span
                  >MW，<span class="text-20px text-[#FF8900]">{{ item.eligibleData['并网'] }}</span>
                </li>
                <!-- <li class="my-10px pl-30px h-40px leading-40px setStatus">
                  三号燃气轮机<span class="text-20px text-[#11D45F]">运行状态</span>，负荷<span
                    class="text-20px text-[#FF8900]"
                    >50</span
                  >MW，<span class="text-20px text-[#FF8900]">并网220KV Ⅲ母线</span>
                </li> -->
              </ul>
            </div>
          </template>
        </CockpitCard>
        <CockpitCard class="h-20rem mb-10px box-border overflow-hidden" cardType="horizontal">
          <template slot-scope="scope">
            <div class="w-full">
              <CardTitle title="#4机组本班工作"></CardTitle>
            </div>
            <div class="h-full overflow-y-scroll">
              <ul class="h-full text-16px !text-[#fff] mb-3rem">
                <li class="my-10px h-36px leading-36px flex items-center ourClass">
                  <span class="beforeImg w-20px h-20px px-20px"></span>
                  <span class="flex-1">
                    发现<span class="text-20px text-[#FF8900]">5</span>条缺陷，其中重要缺陷<span
                      class="text-20px text-[#FF8900]"
                      >1</span
                    >条
                  </span>
                  <span class="afterImg w-20px h-20px px-30px"></span>
                </li>
                <li class="my-10px h-36px leading-36px flex items-center ourClass">
                  <span class="beforeImg w-20px h-20px px-20px"></span>
                  <span class="flex-1">
                    启动<span class="text-20px text-[#FF8900]">15</span>次设备，停止<span
                      class="text-20px text-[#FF8900]"
                      >16</span
                    >次设备
                  </span>
                  <span class="afterImg w-20px h-20px px-30px"></span>
                </li>
                <li class="my-10px h-36px leading-36px flex items-center ourClass">
                  <span class="beforeImg w-20px h-20px px-20px"></span>
                  <span class="flex-1">
                    执行定期工作<span class="text-20px text-[#FF8900]">20</span
                    >项，未执行定期工作<span class="text-20px text-[#FF8900]">2</span>项
                  </span>
                  <span class="afterImg w-20px h-20px px-30px"></span>
                </li>
                <li class="my-10px h-36px leading-36px flex items-center ourClass">
                  <span class="beforeImg w-20px h-20px px-20px"></span>
                  <span class="flex-1">
                    #3机组许可<span class="text-20px text-[#FF8900]">5</span>张工作票，终结<span
                      class="text-20px text-[#FF8900]"
                      >2</span
                    >张工作票
                  </span>
                  <span class="afterImg w-20px h-20px px-30px"></span>
                </li>
                <li class="my-10px h-36px leading-36px flex items-center ourClass">
                  <span class="beforeImg w-20px h-20px px-20px"></span>
                  <span class="flex-1">
                    完成操作票<span class="text-20px text-[#FF8900]">20</span>项
                  </span>
                  <span class="afterImg w-20px h-20px px-30px"></span>
                </li>
                <li
                  class="
                    my-10px
                    flex
                    w-full
                    box-border
                    overflow-hidden
                    h-66px
                    leading-66px
                    ourClass
                  "
                >
                  <span class="beforeImg mt-6px w-20px h-20px px-20px"></span>
                  <span class="w-[calc(100%-100px)] h-full leading-33px">
                    #3机组退出<span class="text-20px text-[#FF8900]">差动保护、过电流保护压板</span
                    >，投入<span class="text-20px text-[#FF8900]">低压测过电流压板</span>
                  </span>
                  <span class="afterImg mt-6px w-20px h-20px px-30px"></span>
                </li>
              </ul>
            </div>
          </template>
        </CockpitCard>
        <CockpitCard class="h-272.56px box-border overflow-hidden" cardType="horizontal">
          <template slot-scope="scope">
            <div class="w-full">
              <CardTitle title="#4机组下班工作"></CardTitle>
            </div>
            <div class="w-full h-full flex">
              <div class="w-1/5">
                <div class="flex my-10px flex-col justify-center">
                  <div class="regularWork mx-auto w-93.21px h-100px"></div>
                  <div class="w-full pt-10px pb-15px text-center text-16px font-bold text-[#fff]">
                    定期工作
                  </div>
                  <div
                    class="
                      w-full
                      flex
                      justify-center
                      items-center
                      h-37px
                      text-center text-16px text-[#fff]
                      relative
                      numItem
                    "
                  >
                    <span class="leading-37px font-bold text-20px fontFamily">10</span>
                    <span class="leading-37px">项</span>
                    <span class="absolute w-20px h-20px right-4px afterImg"></span>
                  </div>
                </div>
              </div>
              <div class="w-2/5">
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">汽机专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">锅炉专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">汽机专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">汽机专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
              </div>
              <div class="w-2/5">
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">汽机专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">汽机专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
                <div
                  class="
                    w-full
                    flex
                    justify-center
                    items-center
                    h-37px
                    text-center text-16px text-[#fff]
                    relative
                    my-10px
                    midItem
                  "
                >
                  <span class="pr-30px">汽机专业</span>
                  <span class="leading-37px font-bold text-20px fontFamily pr-10px">3</span>
                  <span class="leading-37px">项</span>
                  <span class="absolute w-20px h-20px right-4px afterImg"></span>
                </div>
              </div>
            </div>
          </template>
        </CockpitCard>
      </div>
    </div>
    <NotificationDetail
      v-if="notificationShow"
      title="通知详情"
      @close="notificationShow = false"
      :departmentalNotificationDetail="departmentalNotificationDetail"
    ></NotificationDetail>
  </CockpitCard>
</template>

<script>
import { DeptNoticeModuleConfigApi, RotaApi, StateConfigApi } from '@wiz-api/shift-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import dayjs from 'dayjs'
import CardTitle from '@/components/cockpit/CardTitle'
import CockpitCard from '@/components/cockpit/CockpitCard'
import NotificationDetail from './NotificationDetail'

const DataCategory = new DataCategoryApi()
const deptNoticeModuleConfigApi = new DeptNoticeModuleConfigApi()
const stateConfigApi = new StateConfigApi()
const rotaApi = new RotaApi()
export default {
  components: { CockpitCard, CardTitle, NotificationDetail },
  data() {
    return {
      search: {
        time: '',
        workName: '',
      },
      currentTeam: '',
      workType: [],
      notificationShow: false,
      departmentalNotificationList: [],
      departmentalNotificationDetail: {},
      unit3Data: [],
      unit4Data: [],
    }
  },
  methods: {
    showDialog(item) {
      console.log(item, '弹窗数据')
      this.departmentalNotificationDetail = item
      this.notificationShow = true
    },
    // 获取部门通知
    async getDeptNoticeModuleConfigs() {
      const [err, res] = await deptNoticeModuleConfigApi.getDeptNoticeModuleConfigs(1, 999)
      if (!err) {
        // console.log(res, 'res')
        this.departmentalNotificationList = res
      }
    },
    // 获取班次信息
    async getWorkType() {
      const [TimeDataErr, TimeDataListRes] = await DataCategory.getByCode({
        code: 'RotaShiftCode',
      })
      if (!TimeDataErr) {
        this.workType = TimeDataListRes.dataItems
      }
    },
    // 获取当前时间的班次及值次
    async getRotaByDateTime() {
      const params = {
        time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      }
      const [err, res] = await rotaApi.getRotaByDateTime(params)
      if (!err) {
        console.log(res, '获取当前时间的班次及值次')
        this.search.workName = res[0].rotaShift
        this.currentTeam = res[0].rotaType
      }
    },
    // 获取历史班组
    async getRotaByDateTimeAndShift() {
      this.getUnitEligibleData()
      const params = {
        time: dayjs(this.search.time).format('YYYY-MM-DD HH:mm:ss'),
        shift: this.search.workName,
      }
      const [err, res] = await rotaApi.getRotaByDateTimeAndShift(params)
      if (!err) {
        console.log(res, '获取历史班组')
        this.currentTeam = res[0].rotaType
      }
    },
    // 获取机组状态
    async getUnitEligibleData() {
      this.unit3Data = []
      this.unit4Data = []
      const params = {
        dateTime: dayjs(this.search.time).format('YYYY-MM-DD HH:mm:ss'),
        shift: this.search.workName,
      }
      const [err, res] = await stateConfigApi.getUnitEligibleData(params)
      if (!err) {
        console.log(res, '获取机组状态')
        _.forEach(res, (item) => {
          if (item.unitName === '3号机组') {
            this.unit3Data.push(item)
          } else if (item.unitName === '4号机组') {
            this.unit4Data.push(item)
          }
        })
      }
    },
  },
  async created() {
    console.log(DeptNoticeModuleConfigApi.Methods, '方法1')
    console.log(RotaApi.Methods, '方法2')
    console.log(StateConfigApi.Methods, '方法3')
    this.search.time = dayjs().format('YYYY-MM-DD HH:mm:ss')
    this.getDeptNoticeModuleConfigs()
    this.getWorkType()
    await this.getRotaByDateTime()
    this.getUnitEligibleData()
  },
}
</script>

<style scoped lang="scss">
.setStatus {
  background-image: url('../../../assets/images/shift/unitStatus.png');
}

.ourClass {
  background-image: url('../../../assets/images/shift/shiftWork.png');

  .beforeImg {
    background-image: url('../../../assets/images/shift/setWork.png');
    background-position: center;
    background-repeat: no-repeat;
  }
}

.afterImg {
  background-image: url('../../../assets/images/shift/arrow.png');
  background-position: center;
  background-repeat: no-repeat;
}

.regularWork {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('../../../assets/images/shift/regularWork.png');
}

.numItem {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('../../../assets/images/shift/intervalsWork.png');

  .fontFamily {
    font-family: 'Microsoft YaHei UI';
    color: #feff00;
  }
}

.midItem {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('../../../assets/images/shift/profession.png');

  .fontFamily {
    font-family: 'Microsoft YaHei UI';
    color: #ff8900;
  }
}

.midTopImg {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('../../../assets/images/shift/safeoperation.png');
}

.midBottomImg {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('../../../assets/images/shift/departmentalTwo.png');

  .dateImg {
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url('../../../assets/images/shift/departmentalDate.png');
  }

  .midBottomText {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}
</style>
